import React, { useRef, useState, useContext } from 'react';
import { IonModal, IonSlides, IonSlide, IonItem, IonInput, IonButton, IonCol, IonGrid, IonRow} from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { SelectRoom } from './SelectRoom';

export function AddRoomBookedModal(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [currentDate, setCurrentDate] = useState(props.endDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [newRoomID, setNewRoomID] = useState(null);
    let [numberOfNights_toCurrent, setDateRangeNumberOfNights_toCurrent] = useState(null);
    let [numberOfNights, setNumOfNights] = useState(null);

    let [checkInRoomID, setCheckInRoomID] = useState('');
    let [checkInRoomID_multiple, setCheckInRoomID_multiple] = useState(props.checkInRoomID_multiple);


    let [roomSalePrice, setRoomSalePrice] = useState(0.00);
    let [bookingPrice, setBookingPrice] = useState(0.00);
    let [bookingPrice_multiple, setBookingPrice_multiple] = useState([]);
    let [roomSalePrice_multiple, setRoomSalePrice_multiple] = useState([]);

    let [bookingType, setBookingType] = useState([]);


    let [displaySetButton, setDisplaySetButton] = useState('inline-block');
    let [displayResetButton, setDisplayResetButton] = useState('none');

    let [disableBookingButton, setDisableBookingButton] = useState(false);
    let [disableSetButton, setDisableSetButton] = useState(false);
    let [disableResetButton, setDisableResetButton] = useState(false);

    let enterDiscountRef = useRef(0);
    let enterIncreaseRef = useRef(0);


    function addRoom()
    {
        //alert("In addRoom");
        //alert(checkInRoomID_multiple);
        //alert(checkInRoomID_multiple[0]);
    
        let formData = new FormData();

        let totalRooms = [...checkInRoomID_multiple, checkInRoomID];
  

            /*
            formData.append('Tracker', '74113_ADD_ROOM');
            formData.append('user', acctID);
            formData.append('xCheckInRoomID', checkInRoomID);
            formData.append('xCheckInRoomID_multiple', totalRooms);
            formData.append('xCheckInRoomID_reference', checkInRoomID_multiple[0]);
            //formData.append('xCheckInSalesPrice', this.state.checkInSalesPrice);
            //formData.append('xCheckInFirstName', enterFirstNameRef.current.value.replace(/\s+/g, '_'));
            //formData.append('xCheckInLastName', enterLastNameRef.current.value.replace(/\s+/g, '_'));
            //formData.append('xCheckInMobileNumber', enterMobileNumberRef.current.value.replace(/\s+/g, ''));
            //formData.append('xCheckInEmail', enterEmailRef.current.value.replace(/\s+/g, ''));
            //formData.append('xCheckInNonMemberIDType', checkIn_Non_Member_ID_Type);
            //formData.append('xCheckInNonMemberIDNumber', enterID_numberRef.current.value);
            //formData.append('xImageFile', checkInAttachment_ID);
    
            //formData.append('xCheckInAttachment', enterFirstNameRef.current.value);
            //formData.append('xCheckInNonMemberPaymentType', checkInNonMemberPaymentType);
            formData.append('xCheckInDateBooked', startDate);
            formData.append('xCheckOutDateBooked', endDate);
            //formData.append('xCheckInDateBooked', selectCheckInDateRef.current.value);
            //formData.append('xCheckOutDateBooked', selectCheckOutDateRef.current.value);
            formData.append('xCheckInNumberOfNights', numberOfNights);
            //formData.append('xBookingType', bookingType);
            formData.append('xBookingID', props.bookingID);

            formData.append('xCheckInNonMemberPaymentAmount', roomSalePrice);


            const requestOptions = {
                encType: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74113_ADD_ROOM',
                    user: acctID,
                    xCheckInRoomID: checkInRoomID,
                    xCheckInRoomID_multiple: totalRooms,
                    xCheckInRoomID_reference: checkInRoomID_multiple[0],
                    //xCheckInSalesPrice: this.state.checkInSalesPrice,
                    //xCheckInFirstName: enterFirstNameRef.current.value.replace(/\s+/g, '_'),
                    //xCheckInLastName: enterLastNameRef.current.value.replace(/\s+/g, '_'),
                    //xCheckInMobileNumber: enterMobileNumberRef.current.value.replace(/\s+/g, ''),
                    //xCheckInEmail: enterEmailRef.current.value.replace(/\s+/g, ''),
                    //xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                    //xCheckInNonMemberIDNumber:  enterID_numberRef.current.value,
                    //xImageFile: checkInAttachment_ID,
                    //xCheckInAttachment: enterFirstNameRef.current.value,
                    //xCheckInNonMemberPaymentType: checkInNonMemberPaymentType,
                    xCheckInDateBooked: startDate,
                    xCheckOutDateBooked: endDate,
                    //xCheckInDateBooked: selectCheckInDateRef.current.value,
                    //xCheckOutDateBooked: selectCheckOutDateRef.current.value,
                    xCheckInNumberOfNights: numberOfNights,
                    //xBookingType: bookingType,
                    xBookingID: props.bookingID,
                    xCheckInNonMemberPaymentAmount: roomSalePrice,
                    sessionID: sessionID,
                })
            }
        
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
        
                alert(res);
        
                props.closeModal();
        
            })

    }


    function onCheckInRoomIDHandler(event) {

        setBookingType(event.selectedBookingType);
        setCheckInRoomID(event.selectedRoomID);
            //setCheckInRoomID_multiple([...checkInRoomID_multiple, event.selectedRoomID]);
        setRoomSalePrice(event.selectedRoomSalesPrice);
        setBookingPrice(event.selectedRoomSalesPrice);

        //alert('In onCheckInRoomIDHandler');
       // alert(checkInRoomID_multiple);
       // alert(checkInRoomID_multiple[0]);


    }
    
    function onCheckInRoomID_multipleHandler(event) 
    {
    
        setBookingType(event.selectedBookingType);
        setCheckInRoomID_multiple(event.selectedRoomID);
        setRoomSalePrice_multiple(event.selectedRoomSalesPrice);
        setBookingPrice_multiple(event.selectedRoomSalesPrice);
    
        let totalBookingPrice = 0.00;
        for(let col = 0; col < event.selectedRoomSalesPrice.length - 1; ++col)
        {
            //alert(totalBookingPrice);
    
            totalBookingPrice = parseFloat(Number(totalBookingPrice) + Number(event.selectedRoomSalesPrice[col])).toFixed(2);
    
        }
    
        setRoomSalePrice(totalBookingPrice);
        setBookingPrice(totalBookingPrice);
    
    }
    function onCheckInDateHandler(event) {

        setStartDate(event.startDate);
        setEndDate(event.endDate);
        setNumOfNights(event.numOfNights);
    
    }

    function setDiscountHandler()
    {
        if(enterIncreaseRef.current.value > 0)
        {
            setDisableSetButton(true);
            setDisplaySetButton('none');
            setDisplayResetButton('inline-block');
            setRoomSalePrice(roomSalePrice + (roomSalePrice*(enterIncreaseRef.current.value/100)));
            setDisableResetButton(false);  
        }
        else
        {
            setDisableSetButton(true);
            setDisplaySetButton('none');
            setDisplayResetButton('inline-block');
            setRoomSalePrice(roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
            setDisableResetButton(false);
        }
    }
    
    function resetDiscountHandler()
    {
        setDisableResetButton(true);
        setDisplaySetButton('inline-block');
        setDisplayResetButton('none');
        setRoomSalePrice(roomSalePrice);
        enterDiscountRef.current.value = 0;
        enterIncreaseRef.current.value = 0;
        setDisableSetButton(false);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

   // alert('In Add Room Booked');
   // alert(checkInRoomID_multiple);

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
                    <IonGrid> 
                        <IonRow>
                            <IonCol>
                                <label for='newDate'>Select Room: </label>
                            </IonCol>
                            <IonCol>
                                <SelectRoom openModal={ true } onCheckInRoomID= { onCheckInRoomIDHandler} onCheckInRoomID_multiple={onCheckInRoomID_multipleHandler} onCheckInDate={onCheckInDateHandler} selectRoomTracker={'74701B'} tracker={74701} ></SelectRoom>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='4'>
                                <h4>Discount: </h4>
                            </IonCol>
                            <IonCol size='2'>
                                <IonInput style={{display: displaySetButton}} type='number' placeholder='Dn %' ref={enterDiscountRef}></IonInput>
                                <h4 style={{display: displayResetButton}}>{enterDiscountRef.current.value+' %'}</h4>
                            </IonCol>
                            <IonCol size='2'>
                                <IonInput style={{display: displaySetButton}} type='number' placeholder='Up %' ref={enterIncreaseRef}></IonInput>
                                <h4 style={{display: displayResetButton}}>{enterIncreaseRef.current.value+' %'}</h4>
                            </IonCol>
                            <IonCol size='4'> 
                                <IonButton style={{display: displaySetButton}} disabled={disableSetButton} onClick={() => setDiscountHandler()}>Set</IonButton>
                                <IonButton style={{display: displayResetButton}} disabled={disableResetButton} onClick={() => resetDiscountHandler()}>Reset</IonButton>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonButton onClick={addRoom}> Submit </IonButton> 
                            </IonCol>
                        </IonRow>
                    </IonGrid>                        
            <IonButton className='button_closeModal_center' onClick={closeModalHandler}>Cancel </IonButton>
        </IonModal>) : null}
    </React.Fragment>
    )
}